import { type TranslationKey } from '@heidi/runtime/i18n';
import { FormFormat, TemplateCategory } from '@heidi/schema/ml-scribe';
import { isJsonFormTemplate, isXmlFormTemplate } from '@heidi/templates/data';

const termsOfUseLinks = {
  en: 'https://www.heidihealth.com/legal/heidi-scribe-terms-of-use',
  de: 'https://www.heidihealth.com/de-de/legal/heidi-scribe-terms-of-use',
  fr: 'https://www.heidihealth.com/fr-fr/legal/heidi-scribe-terms-of-use',
  es: 'https://www.heidihealth.com/es-es/legal/heidi-scribe-terms-of-use',
  it: 'https://www.heidihealth.com/legal/heidi-scribe-terms-of-use',
  ja: 'https://www.heidihealth.com/legal/heidi-scribe-terms-of-use',
  zh: 'https://www.heidihealth.com/legal/heidi-scribe-terms-of-use',
};

const usagePolicyLinks = {
  en: 'https://www.heidihealth.com/legal/scribe-usage-policy',
  de: 'https://www.heidihealth.com/de-de/legal/scribe-usage-policy',
  fr: 'https://www.heidihealth.com/fr-fr/legal/scribe-usage-policy',
  es: 'https://www.heidihealth.com/es-es/legal/scribe-usage-policy',
  it: 'https://www.heidihealth.com/legal/scribe-usage-policy',
  ja: 'https://www.heidihealth.com/legal/scribe-usage-policy',
  zh: 'https://www.heidihealth.com/legal/scribe-usage-policy',
};

export const getTermsOfUseLink = (locale: string) => {
  return termsOfUseLinks[locale as keyof typeof termsOfUseLinks] ?? termsOfUseLinks.en;
};

export const getUsagePolicyLink = (locale: string) => {
  return usagePolicyLinks[locale as keyof typeof usagePolicyLinks] ?? usagePolicyLinks.en;
};

export type TemplateCategoryDisplayOptions = {
  formFormat?: FormFormat | null;
};

export const getTemplateCategoryDisplayName = (
  category: TemplateCategory,
  t: (key: TranslationKey, options?: Record<string, unknown>) => string,
  options?: TemplateCategoryDisplayOptions
) => {
  switch (category) {
    case TemplateCategory.CONSULT_NOTE_TEMPLATE:
      return t('templateFilters.note');
    case TemplateCategory.DOCUMENT_TEMPLATE:
      return t('templateFilters.document');
    case TemplateCategory.FORM_TEMPLATE: {
      const form = {
        template_category: category,
        form_format: options?.formFormat ?? FormFormat.pdf,
      };
      if (isJsonFormTemplate(form)) return 'JSON';
      return isXmlFormTemplate(form) ? 'XML' : 'PDF';
    }
    case TemplateCategory.ASSESSMENT_TEMPLATE:
      return t('templateFilters.assessment');
    case TemplateCategory.LETTER_TEMPLATE:
      return t('templateFilters.letter');
    case TemplateCategory.PRECHART_TEMPLATE:
      return t('templateFilters.prechart');
    default:
      return t('templateFilters.note');
  }
};
